import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ShopContext } from '../context/shopContext';
import Item from '../components/items/item';
import './css/searchResults.css';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
    const { allProducts } = useContext(ShopContext);
    const query = useQuery();
    const searchTerm = query.get('q')?.toLowerCase() || '';

    const filteredProducts = allProducts?.filter(product =>
        product.name.toLowerCase().includes(searchTerm)
    );

    return (
        <div className="search-results">
            <h2 className="results-heading">Results for "{searchTerm}"</h2>
            {filteredProducts.length > 0 ? (
                <div className="results-grid">
                    {filteredProducts.map(product => (
                        <Item
                            key={product.id}
                            id={product.id}
                            name={product.name}
                            image={product.image}
                            price={product.price}
                            shortDescription={product.shortDescription}
                            longDescription={product.longDescription}
                            occasion={product.occasion}
                        />
                    ))}
                </div>
            ) : (
                <p>No products found.</p>
            )}
        </div>
    );
};

export default SearchResults;
